import { getWholesaleInfo } from '@/lib/pricing';
import '../products.css';
import { fmt } from '@/lib/format';


export default function WholesaleNotice({ item, quantity }) {
  const info = getWholesaleInfo(item, quantity);
  if (!info) return null;

  return (
    <div className={`wholesale-notice ${info.eligible ? 'eligible' : 'pending'}`}>
      {info.eligible ? (
        <p>
          <i className="fas fa-badge-check" />
          با خرید عمده از این فروشنده، قیمت هر واحد <strong>{fmt(info.unitPrice)} تومان</strong> شد و در مجموع{' '}
          <strong>{fmt(info.totalSaving)} تومان</strong> صرفه‌جویی کردید!
        </p>
      ) : (
        <p>
          <i className="fas fa-tag" />
          {fmt(info.unitsNeeded)} عدد دیگر از این فروشنده بخرید (مجموع {fmt(info.minQuantity)} عدد) تا قیمت واحد{' '}
          {fmt(info.unitPrice)} تومان شود و <strong>{fmt(info.potentialSaving)} تومان</strong> صرفه‌جویی کنید!
        </p>
      )}
    </div>
  );
}